import advanceReportingConstants from "@/constants/advanceReportingConstants"

/**
 * Chart Feature Flags
 * Controls visibility of charts across the entire Advanced Reporting module.
 * Set to `false` to disable a chart (overrides backend settings).
 */
const { DEFAULT_CHART_IDS } = advanceReportingConstants

const CHART_FEATURE_FLAGS = Object.freeze({
  [DEFAULT_CHART_IDS.USERS_KPI]: true,
  [DEFAULT_CHART_IDS.SCHOOL_YEAR_PASS_BREAKDOWN]: true,
  [DEFAULT_CHART_IDS.SCHOOL_YEAR_PASS_TREND]: true,
  [DEFAULT_CHART_IDS.PASS_BREAKDOWN]: true,
  [DEFAULT_CHART_IDS.PASS_TREND]: true,
  [DEFAULT_CHART_IDS.TOTAL_PASSES_BY_SCHOOLS]: true,
  [DEFAULT_CHART_IDS.MOST_PASSES_TAKEN]: false,
  [DEFAULT_CHART_IDS.MOST_PASSES_GRANTED]: false,
  [DEFAULT_CHART_IDS.PASS_BREAKDOWN_BY_GRAD_YEAR]: false,
  [DEFAULT_CHART_IDS.AVERAGE_PASS_DURATION]: false,
  [DEFAULT_CHART_IDS.MOST_FREQUENTED_LOCATIONS]: false,
  [DEFAULT_CHART_IDS.TARDY_INFRACTIONS]: true,
  [DEFAULT_CHART_IDS.CONTACT_CONTROL]: true,
  [DEFAULT_CHART_IDS.VISITORS_TREND]: true,
  [DEFAULT_CHART_IDS.ZERO_GRANTERS]: true
})

/**
 * Check if a chart is enabled via feature flags
 * @param {string} chartId - The frontend chart ID (from DEFAULT_CHART_IDS)
 * @returns {boolean} - True if enabled, false if disabled
 */
const isChartEnabled = (chartId) => {
  return CHART_FEATURE_FLAGS[chartId] !== false
}

const pages = {
  mainPage() {
    return {
      name: "Advanced Reporting",
      i18n_name_key: "sidebar_items.advanced_reporting",
      path: advanceReportingConstants.PATHS.REPORT,
      roles: advanceReportingConstants.ADVANCE_REPORTING_ADMIN_ROLES,
      helpKey: "advance_reporting_overview_v0004",
      dependency: "routerDependencies/hasAdvanceReportingAccess"
    }
  },
  scheduledReportsPage() {
    return {
      name: "Scheduled Reports",
      i18n_name_key: "sidebar_items.scheduled_reports",
      path: advanceReportingConstants.PATHS.SCHEDULED_REPORTS,
      roles: advanceReportingConstants.ADVANCE_REPORTING_ADMIN_ROLES,
      helpKey: "advance_reporting_scheduled_reports_v0002",
      dependency: "routerDependencies/hasAdvanceReportingAccess"
    }
  }
}

export default {
  pages,
  CHART_FEATURE_FLAGS,
  isChartEnabled
}
